import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import Link from 'next/link'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { n_aitutor, n_landing } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import links from '../../../../modules/links'
import urls from '../../../../modules/urls'
import { getDday } from '../../../../modules/utils'
import useLandingNav, { ICONS, SUB_NAV } from './useLandingNav'

const SubNav = () => {
  const router = useAppRouter()
  const { t } = useTranslation()

  const { isAITutorMenu, promotions, navigateToPricing, navigateToAITutor, handleStartClick, navigateToLesson } =
    useLandingNav()

  const handleProductClick = () => {
    isAITutorMenu ? navigateToAITutor() : navigateToLesson()
  }

  const handlePurchaseClick = () => {
    navigateToPricing()
  }

  const handleCTAClick = () => {
    isAITutorMenu ? window.open(links.aiTutor.download, '_blank', 'noopener,noreferrer') : handleStartClick()
  }

  const handleTutorClick = () => {
    router.push(urls.student.adv.index(links.framer.advPath['1on1'].tutor))
  }

  const handleMaterialClick = () => {
    router.push(urls.student.adv.index(links.framer.advPath['1on1'].material))
  }

  const handleClickPricing = () => {
    router.push(urls.oneOnOne.pricing)
  }

  return (
    <div className={`${SUB_NAV.HEIGHT} px-32 py-8 flex items-center justify-center bg-white/90`}>
      <nav className={`${SUB_NAV.MAX_WIDTH} w-full flex items-center justify-between`}>
        <ul className="flex gap-x-24 items-center">
          {isAITutorMenu ? (
            <li>
              <button className="flex gap-x-12 items-center" onClick={() => handleProductClick()}>
                <img src={ICONS.aiTutor} alt="student" height={20} width={20} />
                <span className="Title2-18Bd text-purple-700">{t(n_landing.sub_menu_AItutor.title)}</span>
              </button>
            </li>
          ) : (
            <li>
              <button className="flex gap-x-12 items-center" onClick={() => handleProductClick()}>
                <img src={ICONS.student} alt="student" height={20} width={20} />
                <span className="Title2-18Bd text-purple-700">{t(n_landing.sub_menu_1on1.title)}</span>
              </button>
            </li>
          )}
          {promotions &&
            promotions.map((promotion, index) => {
              const { isPublic, label, link, dDay: dDayData } = promotion
              if (!isPublic) return null

              const dDay = dDayData
                ? getDday(
                    new Date(
                      Date.UTC(
                        dDayData?.target_year,
                        dDayData?.target_month - 1,
                        dDayData?.target_day,
                        dDayData?.target_hour
                      )
                    )
                  )
                : null
              const shouldShowDDay = dDay !== null && dDay >= 0 && dDay < 8
              const dDayLabel = shouldShowDDay ? (dDay === 0 ? 'D-Day' : `D-${dDay}`) : null

              return (
                <li key={index}>
                  <Link href={link} className="flex gap-x-4">
                    <span className="Body2-14Md text-gray-500 !font-[400]">{label}</span>
                    {isPublic && dDayLabel && (
                      <div className="px-6 py-2 bg-red-500 rounded-[40px] Caption-12Bd text-white">{dDayLabel}</div>
                    )}
                  </Link>
                </li>
              )
            })}
          {!isAITutorMenu && (
            <>
              <li className="px-6 py-4 hover:bg-gray-50 rounded">
                <button className="flex" onClick={handleClickPricing}>
                  <span className="Body2-14Md text-purple-600 !font-[400]">{t(n_landing.sub_menu_1on1.pricing)}</span>
                </button>
              </li>
              <li className="px-6 py-4 hover:bg-gray-50 rounded">
                <button className="flex" onClick={handleTutorClick}>
                  <span className="Body2-14Md text-gray-500 !font-[400]">{t(n_landing.sub_menu_1on1.list_1)}</span>
                </button>
              </li>
              <li className="px-6 py-4 hover:bg-gray-50 rounded">
                <button onClick={handleMaterialClick}>
                  <span className="Body2-14Md text-gray-500 !font-[400]">{t(n_landing.sub_menu_1on1.list_2)}</span>
                </button>
              </li>
            </>
          )}
        </ul>

        <ul className="flex gap-x-12 items-center">
          <li className="px-6 py-4 hover:bg-gray-50 rounded">
            <button onClick={handleProductClick}>
              <span className="Body2-14Md text-gray-500 !font-[400]">
                {isAITutorMenu ? t(n_landing.sub_menu_AItutor.list_2) : t(n_aitutor.title)}
              </span>
            </button>
          </li>
          <li>
            <DSButton
              size={BUTTON_SIZE.SM}
              type={BUTTON_TYPE.OUTLINE}
              customBorderColor={COLORS.PURPLE600}
              onClick={handlePurchaseClick}
            >
              <DSButton.Label customTxtColor={COLORS.PURPLE600}>{t(n_landing.sub_menu_1on1.btn_1)}</DSButton.Label>
            </DSButton>
          </li>
          <li>
            <DSButton size={BUTTON_SIZE.SM} onClick={handleCTAClick}>
              <DSButton.Label>
                {' '}
                {isAITutorMenu ? t(n_landing.sub_menu_AItutor.btn_2) : t(n_landing.sub_menu_1on1.btn_2)}
              </DSButton.Label>
            </DSButton>
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default SubNav
